/**
 * Shorten a name/word, keeping its extension or not.
 * @param {String} name
 * @param {Boolean} withExtension
 * @returns {HTMLElement[]}
 */
const shortenName = (name, withExtension = false) => {
  const regexSufix = withExtension ? '\\.\\w*$)' : ')'
  const regex = new RegExp(`(.{4})(.+)(\\w{3}${regexSufix}`, 'g')
  const shortenedName = name.replace(regex, '$1...$3')
  return shortenedName
}

export default shortenName



// WEBPACK FOOTER //
// ./src/helpers/shortenName.js